export default __webpack_public_path__ + "static/media/roadToHealth.8df199b7.png";